<template>
  <modal name="ticketEtapaCondicionalEdit" height="auto" width="900" :lazy="true" :scrollable="true"
    :clickToClose="false">
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="xrow">
          <div class="col-1-2">
            <div class="form-group">
              <label>Tipo Ticket</label>
              <select class="form-control" v-model="item.tipo_ticket_id">
                <option v-for="tipo_ticket in tipos_ticket" :key="tipo_ticket.id" :value="tipo_ticket.id">
                  {{ tipo_ticket.chave }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-1-4">
            <div class="form-group">
              <label>Chave Etapa Atual</label>
              <select class="form-control" v-model="item.etapa_atual_chave">
                <option v-for="etapa in etapas" :key="etapa.id" :value="etapa.chave">
                  {{ etapa.chave }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-1-4">
            <div class="form-group">
              <label>Chave Próxima Etapa</label>
              <select class="form-control" v-model="item.proxima_etapa_chave">
                <option v-for="etapa in etapas" :key="etapa.id" :value="etapa.chave">
                  {{ etapa.chave }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" :class="{
        'button button-success': true,
        'button-disabled': validation.hasError(),
      }" v-on:click="handleSubmit()">
        Salvar Alterações
      </button>
      <button type="button" class="button" v-on:click="close">
        Fechar
      </button>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import _keyBy from "lodash/keyBy";
import CloseModal from "../../../../components/CloseModal";
import { get } from "@/helpers/apiRequest";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "Campo de preenchimento obrigatório",
  },
});

export default {
  name: "bannerEdit",
  components: {
    CloseModal,
  },
  props: [
    "onClose",
    "onSubmit",
    "item",
    "close",
  ],
  data() {
    return {
      tipos_ticket: [],
      etapas: [],
      tipoTicketIdOriginal: null,
      etapaChaveOriginal: null,
      proximaEtapaChaveOriginal: null,
    };
  },
  validators: {
    "item.tipo_ticket_id": (value) => Validator.value(value).required(),
    "item.etapa_atual_chave": (value) => Validator.value(value).required(),
    "item.proxima_etapa_chave": (value) => Validator.value(value).required(),
  },
  watch: {
    'item.tipo_ticket_id': function(newVal, oldVal) {
      if (!newVal) {
        this.etapas = [];
        return;
      }
      if (oldVal === undefined || oldVal === null) return;
      if (this.tipoTicketIdOriginal && newVal === this.tipoTicketIdOriginal) {
        this.item.etapa_atual_chave = this.etapaChaveOriginal;
        this.item.proxima_etapa_chave = this.proximaEtapaChaveOriginal;
        this.getEtapas(newVal);
        return;
      }
      if (newVal !== this.tipoTicketIdOriginal) {
        this.item.etapa_atual_chave = null;
        this.item.proxima_etapa_chave = null;
        this.getEtapas(newVal);
      }
    },
  },
  methods: {
    getTiposTicket() {
      get("/admin/sac/tipo-ticket").then((json) => {
        this.tipos_ticket = json;
        if (this.item.tipo_ticket_id) {
          this.getEtapas(this.item.tipo_ticket_id);
        }
      });
    },
    getEtapas(id) {
      get(`/admin/sac/tipo-ticket-etapa/${id}`).then((json) => {
        this.etapas = json;
      });
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.onSubmit(this.item).catch((error) => {
            this.$swal({
              title: "Falha ao salvar alterações",
              text: error.message,
              showCancelButton: false,
              cancelButtonText: "Fechar",
              showConfirmButton: true,
              icon: "error",
            });
          });
        }
      });
    },
  },
  beforeMount() {
    this.getTiposTicket();
    if (this.item.tipo_ticket_id) {
      this.getEtapas(this.item.tipo_ticket_id);
    }
  },
  mounted() {
    this.tipoTicketIdOriginal = this.item.tipo_ticket_id;
    this.etapaChaveOriginal = this.item.etapa_atual_chave;
    this.proximaEtapaChaveOriginal = this.item.proxima_etapa_chave;
  },
}
</script>
